export default __webpack_public_path__ + "static/media/rock_paper_scissor.1eb0dcca.PNG";